export default "__VITE_ASSET__kAxwdmEx__"